export default __webpack_public_path__ + "static/media/reserve.30d7b4ae.svg";